/**
 * Constants for Product Add module
 * Centralized configuration values
 */

// File upload constraints
export const MAX_FILE_SIZE_MB = 5;
export const ALLOWED_FILE_TYPES = ["image/jpeg", "image/png", "image/gif"];

// Product status
export const PRODUCT_STATUS = {
  OPEN: "open",
  PENDING: "pending",
  APPROVED: "Approved",
  REJECTED: "rejected",
  DRAFT: "draft",
};

// Units
export const UNITS = [
  { value: "Liter", label: "Liter" },
  { value: "Milliliter", label: "Milliliter" },
  { value: "Pack of", label: "Pack of" },
  { value: "Gram", label: "Gram" },
  { value: "Kilogram", label: "Kilogram" },
  { value: "piece", label: "Piece" },
];

// Validation messages
export const VALIDATION_MESSAGES = {
  PRODUCT_NAME_REQUIRED: "Product name is required.",
  PRODUCT_NUMBER_REQUIRED: "Product Number is required.",
  CATEGORY_REQUIRED: "Please select a category.",
  SUBCATEGORY_REQUIRED: "Please select a subcategory.",
  DESCRIPTION_REQUIRED:
    "Please enter a meaningful product description (at least 5 characters).",
  PRICE_REQUIRED: "Please enter a valid price",
  IMAGE_REQUIRED: "Please upload an image.",
  INVALID_FILE_TYPE: "Invalid file format. Only JPG, PNG, and GIF are allowed.",
  FILE_TOO_LARGE: `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload a smaller file.`,
  DUPLICATE_PRODUCT_NUMBER:
    "A product with the same product number already exists.",
  DUPLICATE_PRODUCT_NAME:
    "A product with the same product name already exists.",
  DUPLICATE_PRODUCT: "A product with the same name or number already exists.",
  USERNAME_MISSING: "Username is missing. Please log in again.",
};

// Success messages
export const SUCCESS_MESSAGES = {
  PRODUCT_CREATED: "Product submitted successfully",
  PRODUCT_UPDATED: "Product updated successfully",
  STATUS_UPDATED: "Product status updated successfully",
};

// Error messages
export const ERROR_MESSAGES = {
  PRODUCT_CREATE_FAILED: "Failed to submit product",
  PRODUCT_UPDATE_FAILED: "Failed to update product",
  STATUS_UPDATE_FAILED: "Failed to update product status",
  FETCH_CATEGORIES_FAILED: "Error fetching categories",
  FETCH_SUBCATEGORIES_FAILED: "Error fetching subcategories",
  FETCH_LANGUAGES_FAILED: "Failed to load languages",
};

// Excluded words for text capitalization
export const EXCLUDED_WORDS = ["the", "of", "and", "in", "to", "a", "an"];
